const initialState = {
    userRole: {},
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USER_ROLE":
            return { userRole: action.payload };

        default:
            return state;
    }
};

export default userReducer;